import { updateNotificationHasBeenReadDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateNotificationHasBeenReadCallable = getCallable(
  updateNotificationHasBeenReadDefinition,
);
